"use client";

import type { ComponentProps } from "react";
import Link from "next/link";

import { track, type AnalyticsEvent, type AnalyticsParams } from "@/lib/analytics/track";

type TrackProps = {
  event: AnalyticsEvent;
  params?: AnalyticsParams;
};

export function TrackedAnchor({ event, params, onClick, ...props }: ComponentProps<"a"> & TrackProps) {
  return (
    <a
      {...props}
      onClick={(clickEvent) => {
        onClick?.(clickEvent);
        if (!clickEvent.defaultPrevented) track(event, params);
      }}
    />
  );
}

export function TrackedLink({
  event,
  params,
  onClick,
  ...props
}: ComponentProps<typeof Link> & TrackProps) {
  return (
    <Link
      {...props}
      onClick={(clickEvent) => {
        onClick?.(clickEvent);
        if (!clickEvent.defaultPrevented) track(event, params);
      }}
    />
  );
}
